import SkillsDevelopmentLayout from './skills_development_layout.jsx'

const SkillsDevelopmentPage = () => {
  return (
      <SkillsDevelopmentLayout />
  );
};

export default SkillsDevelopmentPage;